import * as React from "react";
import type { SVGProps } from "react";
const SvgCollaboration = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={64}
    height={64}
    fill="none"
    {...props}
  >
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M32.026 7.028a24.08 24.08 0 0 0-9.794 2.065.863.863 0 1 1-.7-1.578 25.804 25.804 0 0 1 10.494-2.213c13.564 0 24.695 10.418 25.83 23.69a.863.863 0 1 1-1.72.147c-1.059-12.386-11.45-22.11-24.11-22.11ZM0 28.404c0-.476.386-.863.863-.863h31.108c.476 0 .863.387.863.863v1.563a1.927 1.927 0 0 1-1.926 1.926H1.926A1.927 1.927 0 0 1 0 29.967v-1.563Zm1.726.863v.7c0 .11.09.2.2.2h28.982a.2.2 0 0 0 .2-.2v-.7H1.726Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M6.961 22.97h18.986c.416 0 .75.335.75.75s-.334.75-.75.75H6.962a.748.748 0 0 1-.75-.75c0-.415.335-.75.75-.75ZM6.961 20.472h18.986c.416 0 .75.334.75.75 0 .414-.334.749-.75.749H6.962a.748.748 0 0 1-.75-.75c0-.415.335-.75.75-.75ZM9.824 15.19H6.728a.517.517 0 0 0-.517.517v3.096c0 .285.232.517.517.517h3.096a.517.517 0 0 0 .517-.517v-3.096a.517.517 0 0 0-.517-.517ZM15.276 15.19H12.18a.517.517 0 0 0-.517.517v3.096c0 .285.231.517.517.517h3.096a.517.517 0 0 0 .516-.517v-3.096a.517.517 0 0 0-.516-.517ZM20.73 15.19h-3.096a.517.517 0 0 0-.517.517v3.096c0 .285.232.517.517.517h3.096a.517.517 0 0 0 .517-.517v-3.096a.517.517 0 0 0-.517-.517ZM26.18 15.19h-3.095a.517.517 0 0 0-.517.517v3.096c0 .285.231.517.517.517h3.095a.517.517 0 0 0 .517-.517v-3.096a.517.517 0 0 0-.517-.517Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M37.09 33.774c-.903 0-1.635.731-1.635 1.635v13.627h.255a7041.732 7041.732 0 0 1 11.876-.032c3.248-.005 6.497-.008 8.935-.004a448.703 448.703 0 0 1 3.195.015V35.409c0-.904-.731-1.635-1.636-1.635H37.09Zm24.352 16.128V35.41a3.361 3.361 0 0 0-3.361-3.361H37.09a3.361 3.361 0 0 0-3.362 3.361v14.493c0 .477.386.863.863.863h.007l-.003-.863.003.863 1.117-.004 2.943-.009c2.435-.007 5.683-.016 8.93-.022 3.248-.005 6.495-.008 8.929-.004 1.217.002 2.23.006 2.937.013a62.155 62.155 0 0 1 .993.016.865.865 0 0 0 .994-.853Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M31.167 49.91c0-.476.386-.862.863-.862h31.108c.476 0 .863.386.863.863v1.563a1.927 1.927 0 0 1-1.926 1.926H33.093a1.927 1.927 0 0 1-1.926-1.926V49.91Zm1.726.864v.7c0 .11.09.2.2.2h28.982a.2.2 0 0 0 .2-.2v-.7H32.893Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M38.124 44.477h18.99c.416 0 .75.335.75.75s-.334.75-.75.75h-18.99a.748.748 0 0 1-.75-.75c0-.415.335-.75.75-.75ZM38.124 41.978h18.99c.416 0 .75.335.75.75s-.334.75-.75.75h-18.99a.748.748 0 0 1-.75-.75c0-.415.335-.75.75-.75ZM40.987 36.697h-3.096a.517.517 0 0 0-.517.517v3.096c0 .285.232.516.517.516h3.096a.517.517 0 0 0 .517-.517v-3.095a.517.517 0 0 0-.517-.517ZM46.442 36.697h-3.096a.517.517 0 0 0-.516.517v3.096c0 .285.23.516.516.516h3.096a.517.517 0 0 0 .517-.517v-3.095a.517.517 0 0 0-.517-.517ZM51.897 36.697H48.8a.517.517 0 0 0-.517.517v3.096c0 .285.232.516.517.516h3.096a.517.517 0 0 0 .517-.517v-3.095a.517.517 0 0 0-.517-.517ZM57.347 36.697h-3.095a.517.517 0 0 0-.517.517v3.096c0 .285.231.516.517.516h3.095a.517.517 0 0 0 .517-.517v-3.095a.517.517 0 0 0-.517-.517Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M5.809 11.84c-.904 0-1.636.731-1.636 1.635v14.06l.255-.002a7040.332 7040.332 0 0 1 11.877-.03c3.248-.007 6.497-.01 8.934-.005a441.82 441.82 0 0 1 3.195.015V13.475c0-.904-.731-1.636-1.635-1.636H5.809ZM30.16 28.4V13.475a3.361 3.361 0 0 0-3.361-3.362H5.809a3.361 3.361 0 0 0-3.362 3.362V28.4c0 .477.387.863.863.863h.008l-.004-.863.004.863 1.116-.004 2.943-.01c2.436-.006 5.683-.015 8.93-.02 3.248-.007 6.495-.01 8.93-.005 1.217.002 2.23.006 2.936.012a60.45 60.45 0 0 1 .993.017.863.863 0 0 0 .994-.853Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M32.026 7.028a24.08 24.08 0 0 0-9.794 2.065.863.863 0 1 1-.7-1.578 25.804 25.804 0 0 1 10.494-2.213c13.564 0 24.695 10.418 25.83 23.69a.863.863 0 1 1-1.72.147c-1.059-12.386-11.45-22.11-24.11-22.11Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      d="m56.463 30.81-1.788-3.096a.517.517 0 0 1 .45-.775h3.574c.398 0 .644.432.449.775L57.36 30.81a.517.517 0 0 1-.893 0h-.004Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M6.998 34.075a.863.863 0 0 1 .933.786c1.06 12.386 11.451 22.11 24.111 22.11 3.486 0 6.802-.735 9.794-2.064a.863.863 0 1 1 .7 1.578 25.806 25.806 0 0 1-10.494 2.213c-13.564 0-24.696-10.419-25.83-23.69a.863.863 0 0 1 .786-.933Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      d="m7.605 33.19 1.788 3.096c.199.343-.051.775-.45.775h-3.57a.519.519 0 0 1-.448-.775l1.787-3.096a.517.517 0 0 1 .893 0Z"
    />
  </svg>
);
export default SvgCollaboration;
